module.exports = __webpack_public_path__ + "img/alaska 1.b950ca37.png";